<si-side-panel
  #sidePanel
  [collapsed]="collapsed"
  [mode]="mode"
  [size]="size"
  (closed)="collapsed = true"
  >
  <div class="container">
    <section>
      <!-- Centered loading spinner -->
      @if (isLoading) {
        <div class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
          <div class="text-center">
            <si-loading-spinner [size]="'lg'"></si-loading-spinner>
            <p class="mt-3 text-muted">Loading projects...</p>
          </div>
        </div>
      }

      <div class="container">
        @if (!isLoading) {
          <div class="row" [hidden]="hideProjectsPanel">
            <div class="col-md p-5 h-100">
              <div class="row p-5">
                <div class="col col-sm-6 center-items">
                  <h2>{{ constants.yourProjects }}</h2>
                </div>
                <div class="col col-sm-6 right-items">
                  <button
                    type="button"
                    class="btn btn-primary me-6"
                    (click)="createProject()"
                    >
                    {{ constants.createProject }}
                  </button>
                </div>
              </div>
              <div class="mb-4 col-12">
                <div class="position-relative">
                  @if (!isSearching) {
                    <i
                      class="search-bar-icon icon element-search text-secondary ng-star-inserted"
                    ></i>
                  }
                  @if (isSearching) {
                    <i
                      class="search-bar-icon icon element-spinner text-secondary ng-star-inserted"
                    ></i>
                  }
                  <input
                    type="text"
                    class="form-control ps-9"
                    [class.pe-10]="currentSearchTerm"
                    placeholder="Search by Subscription Id, Project name or Business Unit and press Enter"
                    (keydown)="updateFilter($event)"
                    [disabled]="isSearching"
                    />
                    <!-- Clear button with × symbol - More prominent design -->
                    @if (currentSearchTerm && !isSearching) {
                      <button
                        type="button"
                        class="btn position-absolute top-50 translate-middle-y clear-search-btn"
                        [class.clear-search-btn-hover]="isHoveringClearBtn"
                        (click)="clearSearch()"
                        (mouseenter)="isHoveringClearBtn = true"
                        (mouseleave)="isHoveringClearBtn = false"
                        title="Clear search and reload projects"
                        >
                        ×
                      </button>
                    }
                  </div>
                </div>
                <div class="table-wrapper">
                  <ngx-datatable
                    #table
                    class="table-element elevation-1"
                    [cssClasses]="tableConfig.cssClasses"
                    [rows]="visibleProjects"
                    [rowHeight]="tableConfig.rowHeight"
                    [columns]="columns"
                    [columnMode]="ColumnMode.force"
                    [headerHeight]="tableConfig.headerHeight"
                    [footerHeight]="0"
                    [ghostLoadingIndicator]="isLoading"
                    [selectionType]="selectionType"
                    [externalPaging]="true"
                    [limit]="20"
                    [offset]="pageNumber"
                    [count]="totalVisibleCount"
                    [virtualization]="false"
                    [scrollbarV]="false"
                    (activate)="onActivate($event)"
                    [rowClass]="getRowClass"
                    siDatatableInteraction
                    >
                    <ngx-datatable-column
                      name="Name"
                      [minWidth]="600"
                      [resizeable]="true"
                      [canAutoResize]="true"
                      [sortable]="false"
                      >
                      <ng-template
                        let-row="row"
                        let-value="value"
                        let-expanded="expanded"
                        ngx-datatable-cell-template
                        >
                        <div
                          class="d-flex align-items-center position-relative"
                          [style.padding-left.px]="((row.level || 0) * 32) + (row.treeStatus === 'disabled' ? 24 : 0)"
                        >
                          <!-- Small loading spinner positioned to the left of the tree arrow -->
                          @if (isRowLoading(row)) {
                            <span
                              class="tree-loading-spinner position-absolute"
                              >
                              <si-loading-spinner [size]="'sm'"></si-loading-spinner>
                            </span>
                          }
                          @if (row.treeStatus === 'collapsed' || row.treeStatus === 'expanded') {
                            <button
                              type="button"
                              class="datatable-tree-button"
                              [attr.aria-label]="row.treeStatus === 'collapsed' ? 'Expand row' : 'Collapse row'"
                              (click)="$event.stopPropagation(); onTreeAction({ row: row })"
                              >
                              <span>
                                @if (row.treeStatus === 'collapsed') {
                                  <i class="icon element-right-2"></i>
                                }
                                @if (row.treeStatus === 'expanded') {
                                  <i class="icon element-down-2"></i>
                                }
                              </span>
                            </button>
                          }
                          @if (row.isFolder) {
                            <span
                              class="icon element-folder me-2"
                            ></span>
                          }
                          <span>{{ value }}</span>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                      prop="numSubscriptions"
                      name="Subscriptions"
                      [minWidth]="10"
                      [resizeable]="true"
                      [canAutoResize]="true"
                      [sortable]="false"
                      >
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        @if (row.isFolder) {
                          <div></div>
                        }
                        @if (row.subscriptionCount > 0) {
                          <div>
                            {{ row.subscriptionCount }}
                          </div>
                        }
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                      prop="numKubernetesClusters"
                      name="Kubernetes Clusters"
                      [minWidth]="10"
                      [resizeable]="true"
                      [canAutoResize]="true"
                      [sortable]="false"
                      >
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        @if (row.isFolder) {
                          <div></div>
                        }
                        @if (row.kubernetesClusterCount > 0) {
                          <div>
                            {{ row.kubernetesClusterCount }}
                          </div>
                        }
                      </ng-template>
                    </ngx-datatable-column>
                    <si-empty-state
                      empty-content
                      icon="element-users"
                      heading="No projects to display"
                    ></si-empty-state>
                  </ngx-datatable>
                  <si-pagination
                    class="ms-auto mt-8"
                    [currentPage]="pageNumber + 1"
                    [totalRowCount]="totalVisibleCount"
                    [pageSize]="pageSize"
                    forwardButtonText="forward"
                    backButtonText="back"
                    (currentPageChange)="pageNumber = $event - 1"
                    >
                  </si-pagination>
                </div>
              </div>
            </div>
          }
          <div class="row">
            <div
              class="p-5 clearfix si-layout-fixed-height h-100"
              [hidden]="hideWelcomeNoProjectsPanel"
              >
              <div class="container">
                <div class="row">
                  <div class="col col-md-9">
                    @if (currentUser !== undefined) {
                      <h2>
                        {{
                        constants.welcome +
                        currentUser.name +
                        constants.welcome_text_partial
                        }}
                      </h2>
                    }
                    @if (currentUser === undefined) {
                      <h2>
                        {{ constants.welcome_text }}
                      </h2>
                    }
                    <p>
                      {{ constants.noPermissionText }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="p-5 clearfix si-layout-fixed-height h-100"
              [hidden]="hideErrorPanel"
              >
              <div class="container">
                <div class="row">
                  <div class="col col-md-9">
                    @if (currentUser !== undefined) {
                      <h2>
                        {{
                        constants.welcome +
                        currentUser.name +
                        constants.welcome_text_partial
                        }}
                      </h2>
                    }
                    @if (currentUser === undefined) {
                      <h2>
                        {{ constants.welcome_text }}
                      </h2>
                    }
                    <p>
                      {{ constants.appDownText }}
                    </p>
                    <p>
                      <a href="https://wiz.io/">{{ constants.wizDashboard }}</a> |
                      <a href="https://clp.siemens.io/cnapp-service/">{{
                        constants.cnappWiki
                      }}</a>
                      |
                      <a
                        href="https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMzI4MTA4MjU3MjgifQ"
                        >{{ constants.vivaEngage }}</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      @if (selectedProject !== undefined) {
        <si-side-panel-content
          class="p-5"
          heading="{{ selectedProject.name }}"
          >
          <app-project-side-panel
            [sidePanelSubscriptionClusterInfo]="sidePanelSubscriptionClusterInfo"
            [sidePanelUserInfo]="sidePanelUserInfo"
            [selectedProject]="selectedProject"
            [selectedProjectParentId]="selectedProjectParentId"
            [folderList]="folderList"
            [isLoadingSubscriptions]="isLoadingSubscriptions"
            [isLoadingClusters]="isLoadingClusters"
            [isLoadingUsers]="isLoadingUsers"
            (sidePanelAction)="sidePanelAction($event)"
          ></app-project-side-panel>
        </si-side-panel-content>
      }
    </si-side-panel>
